/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { Spin, Button } from 'antd';
import { Form } from 'informed';
import { TextField } from '@ui-modules/informed';
import { processNonFederatedUserFlow, notEmptyValidator } from '@common/utils';
import { useAuth } from '@ui-modules/auth';
import { useParamsParse } from '@common/hooks';
import './styles.scss';

const SignInPage: FC = () => {
  const navigate = useNavigate();
  const { parsed: isParsed, userType } = useParamsParse();
  const { firstLoginAttempt: firstLoginAttemptSSO, authorize } = useAuth();

  const [loaderSpinning, setLoaderSpinning] = useState(false);

  useEffect(() => {
    if (firstLoginAttemptSSO && userType !== 'non-federated') {
      setLoaderSpinning(true);

      if (isParsed) {
        authorize?.(userType);
      } else {
        navigate('redirect');
      }
    }
  }, [firstLoginAttemptSSO, isParsed, authorize, navigate, setLoaderSpinning]);

  return (
    <section className="page-login">
      <div className="login">
        <div className="row">
          <span className="login-greeting">
            Welcome to the <br />
            <strong>Drivers Digital Office</strong>
          </span>
        </div>
        <Spin className="login-loading" size="large" spinning={loaderSpinning} />
        {userType === 'non-federated' ? (
          <Form
            className="login-form"
            role="form"
            onSubmit={(state) => {
              setLoaderSpinning(true);
              processNonFederatedUserFlow(
                state.values as { email: string; password: string },
                navigate,
                setLoaderSpinning,
              );
            }}
          >
            <div className="login-field">
              <TextField
                name="email"
                type="email"
                placeholder="Enter your email"
                validate={notEmptyValidator}
              />
            </div>
            <div className="login-field">
              <TextField
                name="password"
                type="password"
                placeholder="Enter your password"
                validate={notEmptyValidator}
              />
            </div>
            <Button className="login-link" type="link" htmlType="submit">
              Sign in
            </Button>
          </Form>
        ) : null}
        {userType !== 'non-federated' && !firstLoginAttemptSSO && (
          <Button
            className="login-link"
            type="link"
            onClick={() => {
              setLoaderSpinning(true);
              authorize?.(userType);
            }}
          >
            Sign in
          </Button>
        )}
      </div>
      <ToastContainer />
    </section>
  );
};

export default SignInPage;
